import React, { useState } from 'react'
import withCapabilities from '../../../hoc/withCapabilities'
import { LogoContainer, LogoImage, LogoSkeleton } from './HeaderLogo.styled'
import { useNavigate } from 'react-router-dom'

const HeaderLogo: React.FC<{ logo: string }> = ({ logo }) => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)

  return (
    <LogoContainer
      onClick={() => {
        navigate('/')
      }}
    >
      {isLoading && <LogoSkeleton variant="rectangular" animation="wave" sx={{ display: 'none' }} />}
      <LogoImage alt="Logo" src={logo} onLoad={() => setIsLoading(false)} style={{ display: isLoading ? 'none' : 'block' }} />
    </LogoContainer>
  )
}

export default withCapabilities(HeaderLogo)
